import React from 'react'
import {search} from "./addressApi";
import PropTypes from "prop-types"
import {formatPostalAddress} from "./util";
import SessionStore from "../../session/SessionStore";
import {Search} from "../../../components/selector/Search";

export class AddressAutoComplete extends React.Component {


  static propTypes = {
    selected: PropTypes.any,
    onSelected: PropTypes.func,
    // decorates Search component, will pass through any other props
  }

  static defaultProps = {
    delay: 750
  }

  getSearchResults = ({ query, offset }) => {
    if (query.length < 4) {
      return Promise.resolve([])
    } else {
      return SessionStore.onceLoaded()
        .then(() => search(query))
        .then(xs => xs.map(x => x.address))
    }
  }
  render() {
    return <Search
      placeholder="Search for an Address..."
      getSearchResults={this.getSearchResults}
      onSelected={this.props.onSelected}
      renderOption={x => formatPostalAddress(x)}
      getKey={x => formatPostalAddress(x)}
      {...this.props}
    />
  }



}